import { Header, User } from '@yy/yycom_header_types';
import axios from 'axios';
import Cookies from 'js-cookie';
import React from 'react';
import './App.scss';
import GuildManage from './components/GuildManage';
import GuildMien from './components/GuildMien';
import Jumbotron from './components/Jumbotron';
import { AnchorSignStatus, SignStatus } from './models/AnchorSignStatus';
import { UserInfoResultData } from './models/UserInfoResult';
import { HTTPService, isAnchor, UserRole } from './util';
import useHiidoPV from './hooks/useHiidoPV';

const PostHiidoPV = () => {
  useHiidoPV('1');
  return null;
};

const queryUserRoleURL = '/zone/userinfo/getUserType.json';
const queryUserInfoURL = '/zone/userinfo/getUserInfo.json';

interface HeadLoaderOnReadyCallbackOption {
  header: Header;
  user: User;
}

export const UserInfoContext = React.createContext<Partial<UserInfoResultData>>(
  {}
);
export const UserRoleContext = React.createContext<UserRole>(0);
const defaultAnchorSignInfo = {
  contract: '',
  code: 0,
  msg: '',
  applyList: {},
  inviteList: {}
};
export const AnchorSignContext = React.createContext<AnchorSignStatus>(
  defaultAnchorSignInfo
);
export const LoginStatusContext = React.createContext<Boolean>(false);

interface AppState {
  isLoggedIn: boolean;
  userRole: UserRole;
  userInfo: Partial<UserInfoResultData>;
  anchorSignStatus: AnchorSignStatus;
}

export default class App extends React.Component {
  static isLoggedIn = () => {
    let result = Cookies.get('udb_oar') && Cookies.get('yyuid');
    return !!result;
  };

  state: AppState = {
    isLoggedIn: App.isLoggedIn(),
    userRole: UserRole.Unknown,
    userInfo: {},
    anchorSignStatus: defaultAnchorSignInfo // 是主播才有这个信息
  };

  onHeaderReady = (): Promise<HeadLoaderOnReadyCallbackOption> =>
    /**
     * Initialize header
     * http://fet.yy.com/widget/header-api/#typescript-%E6%96%B9%E5%BC%8F
     */
    new Promise(resolve => {
      window.headLoader.onReady(egg => {
        resolve(egg);
      });
    });

  fetchInitData = async () => {
    await this.fetchUserRole();
    await this.fetchUserInfo();
    if (isAnchor(this.state.userRole)) {
      await this.fetchAnchorSignStatus();
    }
  };

  initialize = async () => {
    // const { header, user } = await this.onHeaderReady();
    const { header } = await this.onHeaderReady();

    // 初始化header
    header({ target: '#h', fixed: true });

    // // 如果没登录，弹出登录框
    // if (!App.isLoggedIn()) {
    //   user.showYYLoginBox();
    // }

    if (App.isLoggedIn()) {
      this.fetchInitData();
    }

    // 监听登录状态变化
    header.onLogStateChange(isLoggedIn => {
      if (isLoggedIn) {
        this.fetchInitData();
      } else {
        window.location.reload();
      }

      this.setState({ isLoggedIn });
    });
  };

  fetchUserRole = async () => {
    const response = await axios.get(queryUserRoleURL);
    const { code, data, message } = response.data;
    if (code === HTTPService.Ok) {
      this.setState({ userRole: data });
    } else {
      throw new Error(message);
    }
  };

  fetchUserInfo = async () => {
    const response = await axios.get(queryUserInfoURL);
    const { code, data, message } = response.data;

    if (code === HTTPService.Ok) {
      this.setState({ userInfo: data });
    } else {
      throw new Error(message);
    }
  };

  fetchAnchorSignStatus = async () => {
    const { data } = await axios.get('/zone/shuangxuan/status.json');
    // 转换接口返回结构
    if (data.code === SignStatus.InvitedOrApplied) {
      const { applyList, inviteList } = data;
      this.setState({
        anchorSignStatus: {
          ...data,
          applyList: applyList
            ? applyList.reduce((acc: object, cur: any) => {
                return { ...acc, [cur.owuid]: cur };
              }, {})
            : {},
          inviteList: inviteList
            ? inviteList.reduce((acc: object, cur: any) => {
                return { ...acc, [cur.owuid]: cur };
              }, {})
            : {}
        }
      });
      return;
    }
    this.setState({ anchorSignStatus: data });
  };

  componentDidMount() {
    this.initialize();
  }

  render() {
    const { userRole, userInfo, anchorSignStatus, isLoggedIn } = this.state;

    return (
      <LoginStatusContext.Provider value={isLoggedIn}>
        <UserRoleContext.Provider value={userRole}>
          <UserInfoContext.Provider value={userInfo}>
            <AnchorSignContext.Provider value={anchorSignStatus}>
              <div className="App">
                <PostHiidoPV />
                {/*头图模块*/}
                <Jumbotron />
                {/*导流豆腐块模块*/}
                <GuildManage />
                {/*公会排行榜模块*/}
                <GuildMien />
              </div>
            </AnchorSignContext.Provider>
          </UserInfoContext.Provider>
        </UserRoleContext.Provider>
      </LoginStatusContext.Provider>
    );
  }
}
